import { createApp } from 'vue';
import App from '@/App.vue';
import { router } from '@/router';
import { i18n } from '@/plugins/i18n.plugin';
import { setupStaticTranslations } from '@/services/translations';
import '@/assets/css/style.css';

// Workaround for Office.js bug when using modern routing frameworks
// https://github.com/OfficeDev/office-js/pull/2808
function loadOfficeApi(): Promise<void> {
  const replaceState = window.history.replaceState;
  const pushState = window.history.pushState;

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = `${window.location.origin}/officejs/office.js`;
    script.onload = (): void => {
      Office.onReady(() => {
        window.history.replaceState = replaceState;
        window.history.pushState = pushState;
        OfficeExtension.config.extendedErrorLogging = import.meta.env.DEV;
        resolve();
      });
    };
    document.body.appendChild(script);
  });
}

const app = createApp(App);

loadOfficeApi().then(() => {
  setupStaticTranslations();

  app.use(router);
  app.use(i18n);

  app.config.errorHandler = (err, vm, info): void => {
    console.error('Error:', err);
    console.error('Occurred in component:', vm);
    console.error('Additional info:', info);
  };

  router.isReady().then(() => {
    app.mount('#app');
  });
});
